// src/utils.ts
var Any = class {
};
export {
  Any
};
//# sourceMappingURL=react-spring_types.legacy-esm.js.map